const routeConfig = [
	{ path: '/', name: 'Login', component: 'appLogin', useAsDefault: true}
];

export default routeConfig;
